import { EmailLoginPage } from '@ubus/shared';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../components/LanguageSwitcher';

function Login() {
  const { t } = useTranslation();

  return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>
      <div style={{ position: 'absolute', top: 16, right: 16, zIndex: 10 }}>
        <LanguageSwitcher />
      </div>
      <EmailLoginPage
        portalLabel={t('login.portalLabel')}
        titleColor="#ea580c"
        primaryColor="#ea580c"
        emailPlaceholder={t('login.emailPlaceholder')}
        supportHint={t('login.supportHint')}
        labels={{
          email: t('login.email'),
          emailRequired: t('login.emailRequired'),
          password: t('login.password'),
          passwordRequired: t('login.passwordRequired'),
          passwordPlaceholder: t('login.passwordPlaceholder'),
          forgotPassword: t('login.forgotPassword'),
          logIn: t('login.logIn'),
          haveResetLink: t('login.haveResetLink'),
          resetModalTitle: t('login.resetModalTitle'),
          sendResetEmail: t('login.sendResetEmail'),
          cancel: t('login.cancel'),
          registeredEmail: t('login.registeredEmail'),
          enterValidEmail: t('login.enterValidEmail'),
          resetSecurityNote: t('login.resetSecurityNote'),
          loginSuccess: t('login.loginSuccess'),
          loginFailed: t('login.loginFailed'),
        }}
      />
    </div>
  );
}

export default Login;
